// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__4SmgY","gif":"Loading_gif__Cioss","message":"Loading_message__NM-Hh"};